module.exports = __webpack_public_path__ + "static/media/gridOne.5b6060b9.png";